// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar from "./components/Navbar";
// import Hero from "./components/Hero";
// import Category from "./components/Category";
// import Class from "./components/Class";
// import Slider from "./components/Slider";
// import MapsGrid from './components/MapsGrid';
// import AnfrageForm from './components/AnfrageForm';
// import Details from './components/Details'; // Импортируем новый компонент

// import ImageGallery from './components/ImageGallery';
// import ClassDetail from './components/ClassDetail';

// import Loader from './components/Loader';

// function Home() {
//   const [fsImages, setFsImages] = useState([]);
//   const [fzImages, setFzImages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const MEDIA_API_URL = `https://admin.thirsty-shtern.91-151-16-181.plesk.page/files`; // Замените на ваш URL

//   useEffect(() => {
//     const fetchMedia = async () => {
//       try {
//         const response = await axios.get(MEDIA_API_URL, {
//           params: {
//             fields: "id,title,filename_disk,tags", // Запрашиваем необходимые поля
//             limit: 100, // Увеличьте лимит, если необходимо
//           },
//         });

//         if (response.data && response.data.data) {
//           console.log("Полученные медиафайлы:", response.data.data); // Отладка
//           // Фильтруем изображения с тегом 'fs'
//           const filteredFs = response.data.data.filter(image => image.tags && image.tags.includes("fs"));
//           setFsImages(filteredFs);
//           console.log("Отфильтрованные изображения с тегом 'fs':", filteredFs);

//           // Фильтруем изображения с тегом 'fz'
//           const filteredFz = response.data.data.filter(image => image.tags && image.tags.includes("fz"));
//           setFzImages(filteredFz);
//           console.log("Отфильтрованные изображения с тегом 'fz':", filteredFz);
//         } else {
//           setError("Медиафайлы не найдены.");
//         }
//       } catch (err) {
//         setError("Ошибка при загрузке медиафайлов.");
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMedia();
//   }, [MEDIA_API_URL]);

//   if (loading) {
//     return <Loader />;
//   }

//   if (error) {
//     return <p className="error">{error}</p>;
//   }

//   return (
//     <div>
//       <Hero />
//       <Category />
//       <Class />
//       {/* <ImageGallery/> */}

//      {/* Первый слайдер с динамическими изображениями */}
//       <Slider
//         title="Unsere Fahrschule"
//         subtitle="Hier wird Theorie zu Fahrspaß"
//       >
//         {fsImages.map((file) => {
//           const imageUrl = `https://admin.thirsty-shtern.91-151-16-181.plesk.page/assets/${file.filename_disk}`;
//           return (
//             <img
//               key={file.id}
//               className="sliderImg"
//               src={imageUrl}
//               alt={file.title || "Медиафайл"}
//             />
//           );
//         })}
//       </Slider>

//       {/* Второй слайдер с изображениями, отфильтрованными по тегу 'fz' */}
//       <Slider
//         className='blue'
//         title="Unsere Fahrzeuge"
//         subtitle="Modern, sicher und vielseitig"
//       >
//         {fzImages.map((file) => {
//           const imageUrl = `https://admin.thirsty-shtern.91-151-16-181.plesk.page/assets/${file.filename_disk}`;
//           return (
//             <img
//               key={file.id}
//               className="sliderImg"
//               src={imageUrl}
//               alt={file.title || "Медиафайл"}
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = "/images/placeholder.png"; // Убедитесь, что этот файл существует
//               }}
//             />
//           );
//         })}
//       </Slider>
//       <MapsGrid />
//       <AnfrageForm />
//     </div>
//   );
// }

// function App() {
//   return (
//     <Router>
//       <Navbar />
//       <Routes>
//         <Route path="/" element={<Home />} />
//         {/* <Route path="/details/:id" element={<Details />} /> Изменили маршрут на /details/:id */}
//         <Route path="/details/:id" element={<ClassDetail />} />

//         {/* Добавьте другие маршруты здесь при необходимости */}
//       </Routes>
//     </Router>
//   );
// }

// export default App;

// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Navbar from "./components/Navbar";
// import Hero from "./components/Hero";
// import Category from "./components/Category";
// import Class from "./components/Class";
// import Slider from "./components/Slider";
// import MapsGrid from './components/MapsGrid';
// import AnfrageForm from './components/AnfrageForm';
// import Details from './components/Details';
// import ImageGallery from './components/ImageGallery';
// import ClassDetail from './components/ClassDetail';
// import Loader from './components/Loader';

// import AppProvider from './contexts/AppProvider'; // Новый провайдер
// import { MediaContext } from './contexts/MediaContext'; // Импортируем MediaContext
// import { CategoryContext } from './contexts/CategoryContext'; // Импортируем CategoryContext
// import { ClassContext } from './contexts/ClassContext'; // Импортируем ClassContext

// function Home() {
//   // Используем контексты
//   const { fsImages, fzImages, loading: loadingMedia, error: errorMedia } = React.useContext(MediaContext);
//   const { kategorien, loadingKategorien, errorKategorien } = React.useContext(CategoryContext);
//   const { klassen, loadingKlassen, errorKlassen } = React.useContext(ClassContext);

//   if (loadingMedia || loadingKategorien || loadingKlassen) {
//     return <Loader />;
//   }

//   if (errorMedia || errorKategorien || errorKlassen) {
//     return (
//       <div>
//         {errorMedia && <p className="error">{errorMedia}</p>}
//         {errorKategorien && <p className="error">{errorKategorien}</p>}
//         {errorKlassen && <p className="error">{errorKlassen}</p>}
//       </div>
//     );
//   }

//   return (
//     <div>
//       <Hero />
//       <Category /> {/* Теперь компонент Category будет получать данные из контекста */}
//       <Class /> {/* Аналогично */}
//       {/* <ImageGallery/> */}

//       {/* Первый слайдер с динамическими изображениями */}
//       <Slider
//         title="Unsere Fahrschule"
//         subtitle="Hier wird Theorie zu Fahrspaß"
//       >
//         {fsImages.map((file) => {
//           const imageUrl = `https://admin.thirsty-shtern.91-151-16-181.plesk.page/assets/${file.filename_disk}`;
//           return (
//             <img
//               key={file.id}
//               className="sliderImg"
//               src={imageUrl}
//               alt={file.title || "Медиафайл"}
//             />
//           );
//         })}
//       </Slider>

//       {/* Второй слайдер с изображениями, отфильтрованными по тегу 'fz' */}
//       <Slider
//         className='blue'
//         title="Unsere Fahrzeuge"
//         subtitle="Modern, sicher und vielseitig"
//       >
//         {fzImages.map((file) => {
//           const imageUrl = `https://admin.thirsty-shtern.91-151-16-181.plesk.page/assets/${file.filename_disk}`;
//           return (
//             <img
//               key={file.id}
//               className="sliderImg"
//               src={imageUrl}
//               alt={file.title || "Медиафайл"}
//               onError={(e) => {
//                 e.target.onerror = null;
//                 e.target.src = "/images/placeholder.png"; // Убедитесь, что этот файл существует
//               }}
//             />
//           );
//         })}
//       </Slider>
//       <MapsGrid />
//       <AnfrageForm />
//     </div>
//   );
// }

// function App() {
//   return (
//     <AppProvider>
//       <Router>
//         <Navbar />
//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/details/:id" element={<ClassDetail />} />
//           {/* Добавьте другие маршруты здесь при необходимости */}
//         </Routes>
//       </Router>
//     </AppProvider>
//   );
// }

// export default App;

// src/App.js
import React from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import ClassDetail from "./components/ClassDetail";
import CategoryClasses from "./components/CategoryClasses"; // Импортируем новый компонент
import Class from "./components/Class";
import Combinations from "./components/Combinations";
import CombinationDetails from "./components/CombinationDetails";
import Angebot from "./components/Angebot";
import Kursplan from "./components/Kursplan";
import Wissenswertes from "./components/Wissenswertes";
import Beratung from "./components/Beratung";
import INDEV from "./components/INDEV";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import AppProvider from "./contexts/AppProvider"; // Новый провайдер
import FooterWrapper from "./components/FooterWrapper";
import LoginForm from "./components/LoginForm";
import GuestRoute from "./components/GuestRoute";
import Impressum from "./components/Impressum";
import AGB from "./components/AGB";
import Datenschutz from "./components/Datenschutz";
import Widerrufsbelehrung from "./components/Widerrufsbelehrung";

// function App() {
//   const [submissionSuccess, setSubmissionSuccess] = React.useState(false);

//   const handleSubmissionSuccess = (value) => {
//     setSubmissionSuccess(value);
//   };

//   useEffect(() => {
//     if (submissionSuccess) {
//       const timer = setTimeout(() => setSubmissionSuccess(false), 8000);
//       return () => clearTimeout(timer);
//     }
//   }, [submissionSuccess]);

//   return (
//     <AppProvider>
//       <Router>
//         <ScrollToTop />
//         <Navbar />
//         {submissionSuccess && (
//           <div className="successMSG">
//             ✅ Deine Anfrage wurde erfolgreich versendet! Wir melden uns in
//             Kürze per E-Mail.
//           </div>
//         )}

//         <Routes>
//           <Route path="/" element={<Home />} />
//           <Route path="/klassen" element={<Class />} />
//           <Route
//             path="/angebot"
//             element={
//               <Angebot
//               // onSubmissionSuccess={handleSubmissionSuccess}
//               />
//             }
//           />
//           <Route
//             path="/angebot/:id?"
//             element={
//               <Angebot
//               // onSubmissionSuccess={handleSubmissionSuccess}
//               />
//             }
//           />
//           <Route
//             path="/angebot/anfrage/:uuid"
//             element={
//               <Angebot
//               // onSubmissionSuccess={handleSubmissionSuccess}
//               />
//             }
//           />
//           <Route path="/kombis" element={<Combinations />} />
//           <Route path="/kursplan" element={<Kursplan />} />
//           <Route path="/kurzkurse" element={<Kursplan prefilter="kurz" />} />
//           <Route path="/wissenswertes" element={<Wissenswertes />} />
//           {/* <Route path="/angebot" element={<INDEV />} /> */}
//           <Route path="/category/:id" element={<CategoryClasses />} />{" "}
//           {/* Новый маршрут */}
//           <Route path="/details/:id" element={<ClassDetail />} />
//           <Route path="/kombi/:id" element={<CombinationDetails />} />{" "}
//           {/* Новый маршрут для деталей комбинации */}
//           <Route
//             path="/moderator"
//             element={
//               <GuestRoute>
//                 <LoginForm />
//               </GuestRoute>
//             }
//           />
//           <Route path="/agb" element={<AGB />} />
//           <Route path="/datenschutz" element={<Datenschutz />} />
//         </Routes>
//         {/* <Footer /> */}
//         <FooterWrapper />
//       </Router>
//     </AppProvider>
//   );
// }



function App() {
  const [submissionSuccess, setSubmissionSuccess] = React.useState(false);

  const handleSubmissionSuccess = (value) => {
    setSubmissionSuccess(value);
  };

  React.useEffect(() => {
    if (submissionSuccess) {
      const timer = setTimeout(() => setSubmissionSuccess(false), 8000);
      return () => clearTimeout(timer);
    }
  }, [submissionSuccess]);

  return (
    <Router> {/* ⬅️ Вынеси Router НАД AppProvider */}
      
      <AppProvider>  {/* ⬅️ Теперь AppProvider внутри Router */}
        <Helmet>
          {/* <script type="text/javascript" src="https://assets.calendly.com/assets/external/widget.js" async></script> */}
          <script id="Cookiebot" src="https://consent.cookiebot.com/uc.js" data-cbid="a72c20a2-7345-4165-90fd-b9daca14314e" data-blockingmode="auto" type="text/javascript"></script>
        </Helmet>
        <ScrollToTop />
        <Navbar />
        {submissionSuccess && (
          <div className="successMSG">
            ✅ Deine Anfrage wurde erfolgreich versendet! Wir melden uns in
            Kürze per E-Mail.
          </div>
        )}

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/klassen" element={<Class />} />
          <Route path="/klassen/:cat" element={<Class />} />
          <Route path="/angebot" element={<Angebot />} />
          <Route path="/angebot/:id?" element={<Angebot />} />
          <Route path="/angebot/anfrage/:uuid" element={<Angebot />} />
          <Route path="/kombis" element={<Combinations />} />
          <Route path="/kursplan" element={<Kursplan />} />
          <Route path="/kurzkurse" element={<Kursplan prefilter="kurz" />} />
          <Route path="/wissenswertes" element={<Wissenswertes />} />
          <Route path="/category/:id" element={<CategoryClasses />} />
          <Route path="/klassen/:cat/:id" element={<ClassDetail />} />
          <Route path="/klassen/detail/:id" element={<ClassDetail />} />
          <Route path="/kombi/:id" element={<CombinationDetails />} />
          <Route path="/beratung" element={<Beratung />} />
          <Route path="/login" element={<LoginForm />} />
          <Route
            path="/moderator"
            element={
              <GuestRoute>
                <LoginForm moderator="true" />
              </GuestRoute>
            }
          />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/widerrufsbelehrung" element={<Widerrufsbelehrung />} />
        </Routes>
        {/* <Calendly /> */}
        <FooterWrapper />
        
      </AppProvider>
    </Router>
  );
}


export default App;
